module.exports = __webpack_public_path__ + "81f13cabb1c1a44049134bbefe74239e.png";